import { ApiError } from "@vana/core";

export class ListReferralsError extends ApiError {}

export class ListZonesError extends ApiError {}

export class GetReferralError extends ApiError {}

export class ReferralSummaryError extends ApiError {}

export class LinkCandidatesError extends ApiError {}

export class LinkReferralError extends ApiError {}

export class UnlinkReferralError extends ApiError {}

export class UpdateReferralStatusError extends ApiError {}
